export default function ValueSender(values) {
  let tosendval = {};

  if (values.inventoryType === "Dealer's Stock") {
    tosendval = {
      name: values.name,
      model: values.model,
      registrationType: values.registrationType,
      ownerSerial: values.ownerSerial,
      yearOfManufacture: values.yearOfManufacture,
      variant: values.variant,
      color: values.color,
      fuelType: values.fuelType,
      insuranceExpiryDate: values.insuranceExpiryDate,
      registrationExpiryDate: values.registrationExpiryDate,
      registrationDate: values.registrationDate,
      kmsDriven: parseInt(values.kmsDriven),
      price: parseInt(values.price),
      chassisNumber: values.chassisNumber,
      inventoryType: values.inventoryType,
      dealer: JSON.stringify({
        name: values.dealerName,
        email: values.dealerEmail,
        address: values.dealerAddress,
        contact: values.dealerContact,
      }),
      owner: JSON.stringify({
        name: values.ownerName,
        email: values.ownerEmail,
        address: values.ownerAddress,
        contact: values.ownerContact,
      }),
      engineNumber: values.engineNumber,
      vehicleNumber: values.vehicleNumber,
      transmission: values.transmission,
    };
  } else {
    tosendval = {
      name: values.name,
      model: values.model,
      registrationType: values.registrationType,
      ownerSerial: values.ownerSerial,
      yearOfManufacture: values.yearOfManufacture,
      variant: values.variant,
      color: values.color,
      fuelType: values.fuelType,
      insuranceExpiryDate: values.insuranceExpiryDate,
      registrationExpiryDate: values.registrationExpiryDate,
      registrationDate: values.registrationDate,
      kmsDriven: parseInt(values.kmsDriven),
      price: parseInt(values.price),
      chassisNumber: values.chassisNumber,
      inventoryType: values.inventoryType,
      owner: JSON.stringify({
        name: values.ownerName,
        email: values.ownerEmail,
        address: values.ownerAddress,
        contact: values.ownerContact,
      }),
      engineNumber: values.engineNumber,
      vehicleNumber: values.vehicleNumber,
      transmission: values.transmission,
    };
  }
  const body = new FormData();

  //Appending tosendval into body
  for (let [key, value] of Object.entries(tosendval)) {
    body.append(key, value);
  }

  //Appending Images into body
  for (let i = 0; i < values.image.length; i++) {
    body.append("image", values.image[i], values.image[i]?.name);
  }
  body.append("thumbnail", values.thumbnail);
  return body;
}
